import { MicBehaviorContext } from '@vh/components/VHChatInputArea/MicBehaviorProvider.context';
import { useContext, useEffect } from 'react';

/** @type {(active: boolean)=>void} */
export const useUpdateMicActive = (active) => {
  const { setMicActive } = useContext(MicBehaviorContext);
  useEffect(() => {
    setMicActive(active);
  }, [active, setMicActive]);
};
